var path = '/common/formly/inputs/tpl/recaptcha.html';
var html = "<div> <div vc-recaptcha ng-model=model[options.key] key=to.recaptchaKey lang=to.lang></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/recaptcha.html
// module id = 631
// module chunks = 1 3